import update from 'immutability-helper'
import { AnyAction } from 'redux'
import { IBillingCurrentStats } from '@app/@types/myEnergy'
import * as type from '@app/constants/myEnergy/billingPeriod'

export interface IBillingCurrentStatsState {
  billingCurrentStats: IBillingCurrentStats,
}

export const initialState: IBillingCurrentStatsState = {
  billingCurrentStats: {
    billing_period: {
      from: '',
      to: '',
      billing: 0,
      energy: 0,
    },
    total: {
      from: '',
      to: '',
      billing: 0,
      energy: 0,
    },
  },
}

const billingCurrentStats = (
  state: IBillingCurrentStatsState = initialState,
  action: AnyAction,
): IBillingCurrentStatsState => {
  switch (action.type) {
  case type.UPDATE_BILLING_CURRENT_STATS:
    return update(state, {
      billingCurrentStats: { $set: action.stats },
    })
  default:
    return state
  }
}

export default billingCurrentStats
